<div class="page-wrapper">
  <div class="page-content">
    <div class="page-header">
      <hyperkit-typography variant="display" align="center" color="primary"
        >404</hyperkit-typography
      >
      <hyperkit-typography variant="body1" align="center" color="secondary"
        >Oops! We can't find the page you're looking for.</hyperkit-typography
      >
    </div>
    <hyperkit-button
      routerLink="/research"
      variant="standard"
      color="tertiary"
      text="Back to Research"
    ></hyperkit-button>
  </div>
</div>
